import { useIsVercelEnv } from '../useIsVercelEnv';

import { VercelEnvironmentIndicator } from './VercelEnvironmentIndicator/VercelEnvironmentIndicator';

interface Props {
  envKey: string;
  projectKey?: string;
  variant?: 'tag' | 'icon';
}

export function MarketplaceEnvironmentIndicator({ envKey, projectKey, variant = 'icon' }: Props) {
  const isVercel = useIsVercelEnv(envKey, projectKey);

  if (isVercel) {
    return <VercelEnvironmentIndicator variant={variant} />;
  }
  return null;
}
